import { render, staticRenderFns } from "./tourPage03.vue?vue&type=template&id=c31624d6&scoped=true&"
import script from "./tourPage03.vue?vue&type=script&lang=js&"
export * from "./tourPage03.vue?vue&type=script&lang=js&"
import style0 from "./tourPage03.vue?vue&type=style&index=0&id=c31624d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31624d6",
  null
  
)

export default component.exports